<template lang="pug">
page(
    main-title="Калькулятор",
)
    template(slot="description")  Здесь Вы можете расчитать <b>стоимость</b> и 
        | <b>срок</b> доставки в интересующий Вас населенный пункт
    .panel
        .panel-body
            .row
                .col-md-9
                    field(
                        type="select",
                        label="Населённый пункт",
                        :item="calc.city",
                        search-path="/fias/autocomplete/"
                    )
                    template(v-if="!invalidFields.length && !errorMessage")
                        table#sample-table-1.table.table-hover
                            thead
                                tr
                                  th.center #
                                  th Способ доставки
                                  th Срок, дней
                                  th Стоимость, ₽
                            tbody
                                tr(v-for="(item, index) in calculatorDeliveries")
                                  td.center {{ index + 1 }}
                                  td {{ item.name }}
                                  td {{ item.delivery_days }}
                                  td {{ item.delivery_price }}
                    template(v-else)
                        p(v-html="validationMessage")

                    p(v-if="errorMessage") {{ errorMessage }}

                .col-md-3                                                
                    .row
                        .col-md-12
                            .checkbox.clip-check.check-primary.checkbox-inline
                                input#without_discounts_input(
                                    type="checkbox", 
                                    v-model="calc.without_discounts"
                                )
                                label(for="without_discounts_input") Считать без учета правил
                    .row
                        .col-md-12
                            field(
                                type="number",
                                label="Стоимость к оплате, ₽",
                                :item="calc.price_to_pay"
                            )
                    .row
                        .col-md-12
                            field(
                                type="number",
                                label="Объявленная ценность, ₽",
                                :item="calc.price_insurance"
                            )
                    .row
                        .col-md-12
                            field(
                                type="number",
                                label="Вес, грамм",
                                :item="calc.weight"
                            )
                    .row
                        .col-md-12
                            field(
                                type="number",
                                label="Размер X, см",
                                :item="calc.x"
                            ) 
                    .row
                        .col-md-12
                            field(
                                type="number",
                                label="Размер Y, см",
                                :item="calc.y"
                            ) 
                    .row
                        .col-md-12
                            field(
                                type="number",
                                label="Размер Z, см",
                                :item="calc.z"
                            ) 

</template>

<script>
import { mapGetters, mapState } from 'vuex';

import { getAjaxSearchMethod } from '@/utils/vSelect';

import debounce from 'lodash/debounce';
import Inputmask from 'inputmask/dist/inputmask/inputmask';
import cloneDeep from 'lodash/cloneDeep';

const editedFields = ['city', 'price_to_pay', 'price_insurance', 'weight',
    'x', 'y', 'z'];

const fieldsMap = {
    city: 'город',
    price_to_pay: 'стоимость к оплате',
    price_insurance: 'стоимость наложенного платежа',
    weight: 'вес'
};

function calculate() {
    const params = this.getValues();
    this.$store.dispatch('saveCalculatorParams', params);

    this.errorMessage = null;
    this.$store.dispatch('calculateDelivery', params)
        .catch((errorMessage) => {
            this.errorMessage = errorMessage;
            this.canCalculate = false;
        });
}

export default {
    name: 'Calculator',
    created() {
        this.$store.dispatch('loadCalculatorParams')
            .then(() => {
                this.calc = this.getInitial();
            });
    },
    methods: {
        searchCity: getAjaxSearchMethod(
            '/fias/autocomplete/',
            'citiesChoice'
        ),
        calculate,
        debouncedCalculate: debounce(calculate, 900),
        getInitial() {
            let item = cloneDeep(this.$store.state.calculator.calculatorParams);
            for (let field of editedFields) {
                item[field] = {
                    value: item[field],
                    valid: true,
                    message: null
                };
            }

            item.without_discounts = false;
            return item;
        },
        getValues() {
            let values = {};
            for (let field of editedFields) {
                values[field] = this.calc[field].value;
            }

            values.without_discounts = this.calc.without_discounts;

            values.aoguid = values.city.aoguid;
            delete values.city;
            return values;
        }
    },
    computed: {
        invalidFields() {
            let invalidFields = [];
            for (let field in fieldsMap) {
                if (!this.calc[field].value && Number(this.calc[field].value) !== 0) {
                    invalidFields.push(fieldsMap[field]);
                }
            }
            return invalidFields;
        },
        validationMessage() {
            let invalidFields = this.invalidFields;
            if (invalidFields.length) {
                if (invalidFields.length === 1) return `Осталось заполнить только <b>${invalidFields[0]}</b>.`;

                let s = `<b>${invalidFields.slice(0, -1).join('</b>, <b>')}</b> и <b>${invalidFields.slice(-1)}</b>`;
                return `Заполним ${s} и сразу посчититаем сроки и стоимости!`;
            }
        },
        ...mapGetters(['calculatorDeliveries', 'calculatorParams'])
    },
    watch: {
        calc: {
            deep: true,
            handler(val, prevValue) {
                if (this.invalidFields.length) return;
                // Если изменяется город – обновляем сразу, иначе с debounce
                if (prevValue.city.value !== val.city.value) {
                    this.calculate();
                } else {
                    this.debouncedCalculate();
                }
            }
        }
    },
    data() {
        let calc = this.getInitial();

        return {
            errorMessage: null,

            calc
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Calculator.vue